import { Box, RadioGroup, Skeleton } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Button from '../../../../components/Button/Button';
import ButtonGroup from '../../../../components/ButtonGroup/ButtonGroup';
import Radio from '../../../../components/Radio/Radio';
import { AvailableNotificationsResponse } from '../../../../models/MarketsModels';
import { updateRequest } from '../../../../stores/NewConnectionStore';
import { RootState } from '../../../../stores/Store';
import { DeviceType } from '../../../../models/UserDevicesModels';

interface NewConnectionNotificationsStepProps {
  availableNotifications: AvailableNotificationsResponse | undefined;
  nextStep: () => void;
  onClose: () => void;
}
function NewConnectionNotificationsStep({
  availableNotifications,
  nextStep,
  onClose,
}: NewConnectionNotificationsStepProps) {
  const [t] = useTranslation();
  const {
    request: { notificationType },
    device,
  } = useSelector((state: RootState) => state.newConnectionReducer);
  const dispatch = useDispatch();

  /**
   * Handles change of the radio button
   * @param e
   */
  const handleRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(updateRequest({ notificationType: e.target.value as 'PULL' | 'PUSH' }));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <Box sx={{ paddingBottom: '2rem' }}>
        <RadioGroup
          aria-labelledby="notifications-radio"
          name="notifications-radio"
          value={notificationType}
          onChange={handleRadioChange}
        >
          {availableNotifications?.enablePull ? (
            <Radio value="PULL" label={t('pages.eSimManager.newConnectionDrawer.pullNotification')} />
          ) : null}
          {availableNotifications?.enablePush ? (
            <Radio
              value="PUSH"
              label={t('pages.eSimManager.newConnectionDrawer.pushNotification')}
              disabled={device?.deviceType === DeviceType.LAPTOP && !availableNotifications?.enablePushLaptop}
            />
          ) : null}
          {/* {!availableNotifications?.enablePull && !availableNotifications?.enablePush ? (
            <Typography sx={{ paddinTop: '1rem', paddingBottom: '1rem' }}>
              {t('pages.eSimManager.newConnectionDrawer.noNotificationsAvailable')}
            </Typography>
          ) : null} */}
          {!availableNotifications ? (
            <>
              <Skeleton width="100%" />
              <Skeleton width="100%" sx={{ marginTop: '2rem' }} />
            </>
          ) : null}
        </RadioGroup>
      </Box>
      <Box sx={{ marginTop: 'auto' }}>
        <ButtonGroup>
          <Button label={t('common.cancel')} color="alternative2Button" onClick={onClose} />
          <Button label={t('common.continue')} color="primaryButton" disabled={!notificationType} onClick={nextStep} />
        </ButtonGroup>
      </Box>
    </Box>
  );
}

export default NewConnectionNotificationsStep;
